var Component = require("!../../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!../../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6ba215ed\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome-swiper@2.6.7@vue-awesome-swiper/src/swiper.vue
// module id = 591
// module chunks = 64